// extracted by mini-css-extract-plugin
export var circle = "_96-1";
export var exitConfirmationModal = "_96-5";
export var iframe = "_96-0";
export var offline = "_96-3";
export var online = "_96-2";
export var workstationSelectError = "_96-4";